import { createVueApp } from '../utils/create-vue-app';
/* Import components */
import Blobs                 from '../../vue/components/Blobs/Blobs.vue';
import CredentialList        from '../../vue/components/Credentials/CredentialList.vue';
import CertificateHolderList from '../../vue/components/Credentials/CertificateHolderList.vue';
import HeroCollage           from '../../vue/components/Hero/HeroCollage.vue';
import InnovationsList       from '../../vue/components/Innovations/InnovationsList.vue';
import InstructorsFeed       from '../../vue/components/InstructorsFeed/InstructorsFeed.vue';
import JobsFeed              from '../../vue/components/JobsFeed/JobsFeed.vue';
import MegaMenu              from '../../vue/components/MegaMenu/MegaMenu.vue';
import MosaicFeedGrid        from '../../vue/components/MosaicFeedGrid/MosaicFeedGrid.vue';
import OurProcess            from '../../vue/components/OurProcess/OurProcess.vue';
import PartnerList           from '../../vue/components/Partners/PartnerList.vue';
import PeopleCarousel        from '../../vue/components/PeopleCarousel/PeopleCarousel.vue';
import ProjectList           from '../../vue/components/ProjectList/ProjectList.vue';
import PublicationList       from '../../vue/components/PublicationList/PublicationList.vue';
import ResearchTopics        from '../../vue/components/ResearchTopics/ResearchTopics.vue';
import Rolodex               from '../../vue/components/Rolodex/Rolodex.vue';
import SearchPage            from '../../vue/components/Search/SearchPage.vue';
import StoryScroller         from '../../vue/components/StoryScroller/StoryScroller.vue';
import TrainingList          from '../../vue/components/Training/TrainingList.vue';


/* Mount components with props from data attributes */
for (const component of [
  { component: Blobs, ssr: false },
  { component: CredentialList, ssr: false },
  { component: CertificateHolderList, ssr: false },
  { component: HeroCollage, ssr: false },
  { component: InnovationsList, ssr: false },
  { component: InstructorsFeed, ssr: false },
  { component: JobsFeed, ssr: false },
  { component: MegaMenu, ssr: false },
  { component: MosaicFeedGrid, ssr: true },
  { component: OurProcess, ssr: false },
  { component: PartnerList, ssr: false },
  { component: PeopleCarousel, ssr: false },
  { component: PublicationList, ssr: false },
  { component: ProjectList, ssr: false },
  { component: ResearchTopics, ssr: false },
  { component: Rolodex, ssr: false },
  { component: SearchPage, ssr: false },
  { component: StoryScroller, ssr: false },
  { component: TrainingList, ssr: false },
]) {
  const dataVueId = component.component.__name.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase()
  if (component.ssr) {
    createVueApp(`[data-vue-id="${dataVueId}"]`, component.component, true);
  } else {
    createVueApp(`[data-vue-id="${dataVueId}"]`, component.component);
  }
}
